import { Box, styled } from "@mui/material";

export const CardListContainer = styled(Box)(({ theme }) => ({
  "display": "flex",
  "padding": "12px",
  "flexDirection": "column",
  "marginBottom": "0.75rem",
  "justifyContent": "center",
  "alignItems": "flex-start",
  "gap": "8px",
  "alignSelf": "stretch",
  "background": theme.palette.white.main,
  "border": `1px solid ${theme.palette.taupe.dark}`,
  "borderRadius": "12px",
  "&:hover": {
    "cursor": "pointer",
    "boxShadow": "0px 4px 4px rgba(214, 199, 186, 0.25)",
    "> .MuiButtonBase-root": {
      svg: {
        path: {
          transition: ".3s all",
          fill: "#262626",
        },
      },
    },
  },
}));

